// "paper" is the warm off-white, justified serif "day" theme (Apple Books
// look) — the new DEFAULT reader look. "dark", "white", "sepia" and "gray"
// remain selectable.
export type ReaderTheme = "paper" | "white" | "sepia" | "dark" | "gray" | "eink-light" | "eink-dark";

export interface ReaderSettings {
  fontSize: number; // px
  fontFamily: string;
  lineHeight: number; // unitless
  margin: number; // px or vw, interpreted by reader
  theme: ReaderTheme;
  /** Translation overlay mode. When true, every visible page is run
   *  through the local Gemma translator and shown in the target
   *  language; the Play button reads the translated text aloud. Toggled
   *  in Settings, persists across book opens. */
  translateOn: boolean;
  /** Target language for the translation overlay. */
  translateLang: string;
  /** Physical page-button order. "kindle" = upper→next / lower→prev
   *  (the Kindle default, auto-selected on BOOX). "reversed" = the browser
   *  standard (PageUp→prev / PageDown→next). Undefined until seeded once on
   *  first run based on device, so the reversal is applied exactly once. */
  buttonOrder?: "kindle" | "reversed";
}

export const defaultReaderSettings: ReaderSettings = {
  fontSize: 21,
  fontFamily: '"Iowan Old Style", "Palatino Linotype", "Georgia", "Charter", serif',
  lineHeight: 1.58,
  margin: 26,
  // 2026-09-29: dark by default, matching the rest of 1n2.org and the
  // manifest's #000000 background/theme colour. "paper" and the others stay
  // in the theme switcher; anyone who already picked one keeps it, since
  // stored settings override this default.
  theme: "dark",
  translateOn: false,
  translateLang: "English",
};
